<div mat-dialog-content>
    <div class="mat-dialog-content">
        <div class="head-modal-list">
            <h2>Deseja excluir o Aconselhamento?</h2>
         </div>
         
         <div class="body-modal-list">
            Ao continuar, este aconselhamento será excluído de todos os protocolos aos quais está vinculado.
         </div>
         <div class="footer-modal-list">
            <button mat-button class="btn-primary block" (click)="clickDelete()">
                <span *ngIf="isLoading == false">Sim, excluir</span>
                <mat-spinner [diameter]="30" class="mat-spinner-btn" *ngIf="isLoading == true"></mat-spinner>
            </button>
            <button mat-button class="btn-secundary block"(click)="clickCancel()">Cancelar</button>
        </div>
    </div>
</div>
